import ReactMounter from 'lib/ReactMounter';
import PropertyTransactionProcessPage from 'pages/PropertyTransactionProcessPage/PropertyTransactionProcessPage';

ReactMounter.registerComponentToMountOnLoad('PropertyTransactionProcessPage', PropertyTransactionProcessPage);
